import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const CircuitAndPacketSwitching = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Circuit and Packet Switching"
    videos={[
      "https://www.youtube.com/embed/-HlJ4psu5aU"
    ]}
    takeaways={[
      { text: "Very easy topic, learn the diagrams for each switching technique." }
    ]}
    questions={[
      "Differentiate between Circuit switching and datagram packet switching.",
      "Discuss the various phases in Circuit Switching.",
      "Consider an application that transmits data at a constant rate (for example, the sender generates an n-bit unit of data every 'k' time units, where 'k' is small and fixed). Also, when such an application starts, it will continue running for a relatively long period of time. Answer the following questions, briefly justifying your answer: i. Would a packet-switched network or a circuit-switched network be more appropriate for this application? Why? ii. Suppose that a packet-switched network is used and the only traffic in this network comes from such applications as described above. Furthermore, assume that the sum of the application data rates is less than the capacities of each and every link. Is some form of congestion control needed? Why? iii. What advantage does a circuit-switched network have over a packet-switched network?",
      "Enumerate the usage of circuit switching network to connect eight telephones in a small area with a diagram. In addition, analyse the delay and efficiency in circuit switching network.",
      "Consider that the data is packetized before transmission and the endpoint devices do not have any technique to determine if the data is out of order. Which switching will be suitable in this scenario and why? Explain the entire process for this switching using suitable diagrams.",
      "Relevant points substantiate the need for switching techniques in data communication. With a neat diagram, discuss the workings of packet-switching approaches."
    ]}
    exampleVideos={[]}
  />
);
}

export default CircuitAndPacketSwitching;
